import { useEffect } from 'react'


const QRMessages = ({ data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                {/* {isActiveWomensMode ? (
                    // <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                )} */}
                {/* <img src='/img/page/backgrounds/background-womens-day-2026.png' className='SelfieFan__Screen__Selfie__Background__Image' /> */}

                {/* Atributos vitales para fondos: 
                  autoPlay: inicia solo
                  loop: se repite infinitamente
                  muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                  playsInline: previene que en iOS el video se abra a pantalla completa
                */}
                
                {/* {isActiveWomensMode ? (
                    // <video 
                    //     src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    //     className='SelfieFan__Screen__QR__Background__Video' 
                    //     autoPlay loop muted playsInline 
                    // />
                    <img src='/img/page/backgrounds/background-womens-day-2026.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <video 
                        src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                        className='SelfieFan__Screen__QR__Background__Video' 
                        autoPlay loop muted playsInline 
                    />
                )} */}

                <img src="/img/page/backgrounds/background.png" className="Screen__Thanks__Background__Image" alt="" />
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'> {/* Container-FullHeight */}
                <div className='SelfieFan__Screen__QR__Container'>
                    {isActiveWomensMode ? (
                        <div className='SelfieFan__Screen__QR__Container__Instructions' style={{ backgroundColor: 'rgba(255,255,255,0.85)' }}>
                            <img src="/img/page/xolos-five-black.png" className="SelfieFan__Screen__QR__Container__Instructions__Logo" alt="Logo" />
                            <p className='SelfieFan__Screen__QR__Container__Instructions__Text Text--Gradient--Womens'>ESCANEA EL CÓDIGO Y ENVÍA UN MENSAJE DE APOYO</p>
                        </div>
                    ) : isActiveWomensMode === false && (
                        <div className='SelfieFan__Screen__QR__Container__Instructions'>
                            <img src="/img/page/xolos-five.png" className="SelfieFan__Screen__QR__Container__Instructions__Logo" alt="Logo" />
                            <p className='SelfieFan__Screen__QR__Container__Instructions__Text'>ESCANEA EL CÓDIGO Y ENVÍA UN MENSAJE DE APOYO</p>
                        </div>
                    )}
                    
                    <img src='/img/page/qr/messages-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
                </div>
            </div>

            {isActiveWomensMode ? (
                <footer className='SelfieFan__Screen__QR__Footer FooterCredits' style={{ color: '#000000', backgroundColor: 'rgba(255,255,255,0.85)', padding: '0 16px', borderRadius: '16px' }}>Hecho con ♥ por Interaktia | 2026</footer>
            ) : isActiveWomensMode === false && (
                <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
            )}
        </>
    )
}

export { QRMessages };









// import { useEffect, useState } from 'react'


// const QRMessages = ({ data, isActiveWomensMode }) => {

//     // --- ESTADOS PARA EL EFECTO DE ESCRITURA ---
//     const [text, setText] = useState('');
//     const [isDeleting, setIsDeleting] = useState(false);
//     const [loopNum, setLoopNum] = useState(0);
//     const [typingSpeed, setTypingSpeed] = useState(150);

//     // Las frases que se van a rotar
//     // const phrases = [
//     //     "TU MEDIA NARANJA",
//     //     "ESA PERSONA ESPECIAL",
//     //     "TU CRUSH"
//     // ];

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//         } catch (error) {
            
//         }
//     }

//     // Efecto de carga inicial (Tu código original)
//     useEffect(() => {
//         LoadPage()
//     }, [])

//     // --- LÓGICA MÁQUINA DE ESCRIBIR ---
//     // useEffect(() => {
//     //     const handleTyping = () => {
//     //         const i = loopNum % phrases.length;
//     //         const fullText = phrases[i];

//     //         setText(isDeleting 
//     //             ? fullText.substring(0, text.length - 1) 
//     //             : fullText.substring(0, text.length + 1)
//     //         );

//     //         // Velocidad base
//     //         let speed = 150;

//     //         if (isDeleting) {
//     //             speed /= 2; // Borra más rápido
//     //         }

//     //         if (!isDeleting && text === fullText) {
//     //             // Terminó de escribir la frase completa: Espera un momento
//     //             speed = 2000; 
//     //             setIsDeleting(true);
//     //         } else if (isDeleting && text === '') {
//     //             // Terminó de borrar: Pasa a la siguiente frase
//     //             setIsDeleting(false);
//     //             setLoopNum(loopNum + 1);
//     //             speed = 500;
//     //         }

//     //         setTypingSpeed(speed);
//     //     };

//     //     const timer = setTimeout(handleTyping, typingSpeed);

//     //     return () => clearTimeout(timer);
//     // }, [text, isDeleting, loopNum, typingSpeed, phrases]);
    

//     return (
//         <>
//             {/* Estilo local para el cursor parpadeante */}
//             {/* <style>
//                 {`
//                     .blinking-cursor {
//                         font-weight: 100;
//                         font-size: 1.2em;
//                         color: white;
//                         animation: blink 1s step-end infinite;
//                     }
//                     @keyframes blink {
//                         0%, 100% { opacity: 1; }
//                         50% { opacity: 0; }
//                     }
//                 `}
//             </style> */}

//             <div className='SelfieFan__Screen__QR__Background'>
//                 {isActiveWomensMode ? (
//                     <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 ) : isActiveWomensMode === false && (
//                     <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 )}
//             </div>

//             {/* <div className='QRMessages__Screen__Title'>
//                 <p className='QRMessages__Screen__Title__Text'>
//                     ENVÍA UN MENSAJE A <span>{text}</span><span className="blinking-cursor">|</span>
//                 </p>
//             </div> */}

//             <div className='QRMessages__Screen__Title'>
//                 <p className='QRMessages__Screen__Title__Text'>
//                     ENVÍA UN MENSAJE DE APOYO
//                 </p>
//             </div>

//             <div className='QRMessages__Screen__QR'>
//                 <img src='/img/page/qr/messages-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' alt="QR" />
//             </div>

//             <footer className='SelfieFan__Screen__QR__Footer FooterCredits QRMessages__Screen__Footer'>Hecho con ♥ por Interaktia | 2026</footer>
//         </>
//     )
// }

// export { QRMessages };